module.exports = __webpack_public_path__ + "img/Penny-Pinch-02.7073139a.jpg";